import { type FC, memo, useEffect } from 'react';

import type { RendererActions } from '@atlaskit/renderer/actions';

import { useRendererActionsDispatch } from './RendererActionsContext.tsx';

type RendererActionsListenerProps = {
	actions: RendererActions;
	pageId?: string;
};

export const RendererActionsListener: FC<RendererActionsListenerProps> = memo(
	({ actions, pageId }) => {
		const { setRendererActions } = useRendererActionsDispatch();

		useEffect(() => {
			setRendererActions(actions, pageId);
		}, [actions, pageId, setRendererActions]);

		return null;
	},
);
